export enum PartnerMutations {
  RESET = "RESET",
  SET_COST = "SET_COST",
  SET_COSTS = "SET_COSTS",
  ADD = "ADD",
}
